import { useTranslate } from '@tolgee/react';
import React, { useState } from 'react';
import { Dropdown, ButtonGroup, Button } from 'react-bootstrap';

interface TextAlignDropdownProps {
  alignment: string;
  onChange: (alignment: 'left' | 'center' | 'right') => void;
}

const TextAlignDropdown: React.FC<TextAlignDropdownProps> = ({
  alignment,
  onChange
}) => {
  const { t } = useTranslate();
  const [show, setShow] = useState(false);
  const getIconClass = () => {
    switch (alignment) {
      case 'center':
        return 'fa-duotone fa-align-center fs-6';
      case 'right':
        return 'fa-duotone fa-align-right fs-6';
      default:
        return 'fa-duotone fa-align-left fs-6';
    }
  };

  return (
    <div
      className="dropdown"
      style={{
        aspectRatio: 1,
        width: '40px'
      }}
    >
      <button
        className="border rounded-2 p-2 btn btn-light dropdown-toggle btn-sm"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{
          aspectRatio: 1,
          width: '40px'
        }}
      >
        <i
          className={getIconClass()}
          style={{ paddingRight: 0, paddingLeft: '4px' }}
        ></i>
      </button>

      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li onClick={() => onChange('left')}>
          <div className="dropdown-item">
            <i className="fa-duotone fa-align-left fs-6 me-2"></i>{' '}
            {t('lomavisCreator.overlay.left')}
          </div>
        </li>
        <li onClick={() => onChange('center')}>
          <div className="dropdown-item">
            <i className="fa-duotone fa-align-center fs-6 me-2"></i>{' '}
            {t('lomavisCreator.overlay.center')}{' '}
          </div>
        </li>
        <li onClick={() => onChange('right')}>
          <div className="dropdown-item">
            <i className="fa-duotone fa-align-right fs-6 me-2"></i>{' '}
            {t('lomavisCreator.overlay.right')}{' '}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default TextAlignDropdown;
